import { Spin } from 'antd'
import React from 'react'
import { StyledDHSCheckInsuranceLoadingContainer } from './DHSCheckInsurance.styled'

export const DHSCheckInsuranceLoading: React.FC = React.memo(() => {
  return (
    <StyledDHSCheckInsuranceLoadingContainer>
      <Spin size="large" tip="Loading DHS Check Insurance...">
        <div style={{ padding: 50 }} />
      </Spin>
    </StyledDHSCheckInsuranceLoadingContainer>
  )
})
